"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Core = __importStar(require("../index"));

var app_1 = __importDefault(require("../constants/actions/app"));

var remote_followed_groups_1 = __importDefault(require("../constants/actions/remote-followed-groups"));

var remote_followed_items_1 = __importDefault(require("../constants/actions/remote-followed-items"));

var remote_groups_1 = __importDefault(require("../constants/actions/remote-groups"));

var remote_item_review_1 = __importDefault(require("../constants/actions/remote-item-review"));

var remote_items_1 = __importDefault(require("../constants/actions/remote-items"));

var remote_user_1 = __importDefault(require("../constants/actions/remote-user"));

var remote_groups_search_1 = __importDefault(require("../constants/actions/remote-groups-search"));

var my_contributions_1 = __importDefault(require("../constants/actions/my-contributions"));

var auth_1 = __importDefault(require("../constants/actions/auth"));

var remote_group_edit_1 = __importDefault(require("../constants/actions/remote-group-edit"));

var remote_item_edit_1 = __importDefault(require("../constants/actions/remote-item-edit"));

function default_1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    start_at: -1,
    install_at: -1,
    started: false,
    last_error: null,
    fore_noti: null,
    is_group_swiped: false,
    is_item_swiped: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case app_1.default.INIT:
      return Object.assign({}, state, {
        start_at: action.start_at,
        install_at: action.install_at,
        started: true
      });

    case app_1.default.CLEAR_LAST_ERROR:
      return Object.assign({}, state, {
        last_error: null
      });

    case app_1.default.SET_GROUP_SWIPED:
      return Object.assign({}, state, {
        is_group_swiped: action.bool
      });

    case app_1.default.SET_ITEM_SWIPED:
      return Object.assign({}, state, {
        is_item_swiped: action.bool
      });

    case app_1.default.SET_FOREGROUND_NOTIFICATION:
      return Object.assign({}, state, {
        fore_noti: action.data
      });

    case app_1.default.CLEAR_FOREGROUND_NOTIFICATION:
      return Object.assign({}, state, {
        fore_noti: null
      });

    case app_1.default.CLEAR_ERROR_NOTI:
      return Object.assign({}, state, {
        last_error: null,
        fore_noti: null
      });

    case remote_followed_groups_1.default.FETCH_FAILURE:
    case remote_followed_groups_1.default.FOLLOW_FAILURE:
    case remote_followed_groups_1.default.RELOAD_FAILURE:
    case remote_followed_groups_1.default.UNFOLLOW_BY_ID_FAILURE:
    case remote_followed_groups_1.default.UNFOLLOW_FAILURE:
    case remote_followed_items_1.default.FETCH_FAILURE:
    case remote_followed_items_1.default.FOLLOW_FAILURE:
    case remote_followed_items_1.default.RELOAD_FAILURE:
    case remote_followed_items_1.default.UNFOLLOW_BY_ID_FAILURE:
    case remote_followed_items_1.default.UNFOLLOW_FAILURE:
    case remote_groups_1.default.ADD_FAILURE:
    case remote_groups_1.default.EDIT_FAILURE:
    case remote_groups_1.default.GET_LIST_FAILURE:
    case remote_groups_1.default.RELOAD_FAILURE:
    case remote_groups_1.default.REMOVE_FAILURE:
    case remote_item_review_1.default.CLEAR_FAILURE:
    case remote_item_review_1.default.INIT_FAILURE:
    case remote_items_1.default.ADD_FAILURE:
    case remote_items_1.default.CONTRIBUTE_FAILURE:
    case remote_items_1.default.EDIT_FAILURE:
    case remote_items_1.default.GET_LIST_FAILURE:
    case remote_items_1.default.RELOAD_FAILURE:
    case remote_items_1.default.REMOVE_FAILURE:
    case remote_items_1.default.DETACH_FAILURE:
    case remote_items_1.default.RESUBMIT_FAILURE:
    case remote_items_1.default.GET_FOLLOWED_STATUS_FAILURE:
    case auth_1.default.CREATE_ANONYMOUS_USER_FAILURE:
    case auth_1.default.CREATE_FACEBOOK_USER_FAILURE:
    case auth_1.default.CREATE_GOOGLE_USER_FAILURE:
    case auth_1.default.GET_AUTH_INFO_FAILURE:
    case auth_1.default.LINK_FACEBOOK_USER_FAILURE:
    case auth_1.default.LINK_GOOGLE_USER_FAILURE:
    case auth_1.default.SIGN_OUT_FAILURE:
    case auth_1.default.DEVICE_SIGN_OUT_FAILURE:
    case remote_groups_search_1.default.SEARCH_FAILURE:
    case remote_groups_search_1.default.RELOAD_FAILURE:
    case remote_groups_search_1.default.FETCH_MORE_FAILURE:
    case remote_group_edit_1.default.ADD_FAILURE:
    case remote_group_edit_1.default.EDIT_FAILURE:
    case remote_item_edit_1.default.ADD_FAILURE:
    case remote_item_edit_1.default.EDIT_FAILURE:
    case remote_item_edit_1.default.CONTRIBUTE_FAILURE:
    case remote_item_edit_1.default.FETCH_ITEMS_FAILURE:
    case my_contributions_1.default.GET_DETACHED_FAILURE:
    case my_contributions_1.default.GET_PENDING_FAILURE:
    case my_contributions_1.default.GET_REJECTED_FAILURE:
    case my_contributions_1.default.RELOAD_DETACHED_FAILURE:
    case my_contributions_1.default.RELOAD_REJECTED_FAILURE:
    case my_contributions_1.default.RELOAD_PENDING_FAILURE:
    case my_contributions_1.default.ATTACH_ITEM_FAILURE:
    case remote_user_1.default.HOOK_EXTRA_INFO_FAILURE:
    case remote_user_1.default.CHANGE_NICKNAME_FAILURE:
    case app_1.default.SET_LAST_ERROR:
    case app_1.default.INIT_FAILURE:
      {
        if (__DEV__) {
          console.log(action.error);
        } else {
          Core.triggerErrorHandler(action.error);
        }

        return Object.assign({}, state, {
          last_error: action.error
        });
      }

    default:
      return state;
  }
}

exports.default = default_1;